<div class="h-dvh overflow-hidden">
  <router-outlet />
</div>

@if (showSplash()) {
  <div
    class="fixed inset-0 z-[9999] flex items-center justify-center bg-surface-0 transition-opacity duration-500"
    [class.opacity-0]="fadingOut()">
    <img src="images/logo.svg" alt="BuildersTurf" width="280" style="opacity:.85">
  </div>
}
